import moment from "moment";
import "moment/locale/en-au";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";
import * as serviceWorker from "./serviceWorker";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/font.css";
import "./assets/css/font-awsome.css";
import "./assets/css/style.css";
import "./assets/css/custom.css";
import "./assets/scss/custom.scss";
import "bootstrap/dist/js/bootstrap.bundle.min";

moment.locale("en-au");

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <HelmetProvider>
        <App />
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          limit={3}
        />
      </HelmetProvider>
    </BrowserRouter>
  </Provider>
);

reportWebVitals();
serviceWorker.unregister();
